export default __webpack_public_path__ + "static/media/chart-pie.ca9647d3.svg";